import { Link } from "react-router-dom";
import PageContainer from "@/components/base/PageContainer";

const ENTRIES = [
  { to: "/category?type=movie", label: "电影", icon: "ri-movie-line" },
  { to: "/category?type=tv", label: "电视剧", icon: "ri-tv-2-line" },
  { to: "/category?region=国产", label: "国产", icon: "ri-home-heart-line" },
  { to: "/category?region=欧美", label: "海外", icon: "ri-earth-line" },
  { to: "/category?sort=rating", label: "评分高", icon: "ri-award-line" },
  { to: "/category?sort=hot", label: "热门", icon: "ri-fire-line" },
];

export default function CategoryShortcuts() {
  return (
    <PageContainer className="-mt-8 md:-mt-12 relative z-30">
      <div className="grid grid-cols-3 md:grid-cols-6 gap-2 md:gap-3 rounded-lg bg-background-50 border border-background-200 p-3 md:p-4">
        {ENTRIES.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group flex flex-col items-center gap-2 py-3 rounded-md hover:bg-primary-50 transition-colors cursor-pointer"
          >
            <span className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center group-hover:bg-accent-500 group-hover:text-white transition-colors">
              <i className={`${entry.icon} text-2xl`} />
            </span>
            <span className="text-xs md:text-sm font-label text-foreground-700 group-hover:text-primary-700">
              {entry.label}
            </span>
          </Link>
        ))}
      </div>
    </PageContainer>
  );
}